export const resolveMd5BodyChecksumConfig = (input) => input;
